import { Person } from "@/Common/Models/Person/Person";
import { AdministrativeCode, PopulationBasedFundingEventAction, PopulationBasedFundingEventDeregisteredReason } from "../UI/Enums";

class PopulationBasedFundingFormData {
    public SelectedPhysician: Person;
    public SelectedEffectiveDate: Date;
    public DeregistrationOrProposalCustomReason: string;
    public Notes: string;
    public NotesHistory: string[];
    public SelectedDeregisterReason?: PopulationBasedFundingEventDeregisteredReason;
    public WillContinueToSeePhysician: boolean;
    public ActionEnum: PopulationBasedFundingEventAction;
    public AdministrativeCode: AdministrativeCode;

    public constructor(fields?: Partial<PopulationBasedFundingFormData>) {
        Object.assign(this, fields);
    }
}

enum PopulationBasedFundingFormEnum {
    Register,
    Deregister
}

export { PopulationBasedFundingFormData, PopulationBasedFundingFormEnum };
